// extracted by mini-css-extract-plugin
export var optionGrid = "_5x-7";
export var optionList = "_5x-6";
export var questionsBlock = "_5x-9";
export var spacer = "_5x-5";
export var stepCenteredContent = "_5x-3";
export var stepInner = "_5x-0";
export var stepInnerFullWidth = "_5x-1";
export var stepInnerLockScroll = "_5x-2";
export var stepTransitionFrame = "_5x-4";
export var welcomeBlock = "_5x-8";